import Vue from 'vue'
import store from './store'
import router from './router'
import './plugins/ant-design-vue.js'
import './plugins/vue-cookie'
import './plugins/axios'
import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
